"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Z_INDEX = exports.TRANSLATION = exports.TEXT_TYPE = exports.TAGS = void 0;
var Z_INDEX = {
  FLIGHT_DETAILS: 1010
};
exports.Z_INDEX = Z_INDEX;
var TRANSLATION = {
  bestDeal: 'Best deals with AirAsia'
};
exports.TRANSLATION = TRANSLATION;
var TAGS = {
  VTL: {
    title: 'Vaccinated Travel Lane',
    label: 'Make sure that you’ve fulfilled all {VTL travel requirements} to board this flight',
    color: 'blueLight'
  },
  airasiaPlus: 'Airasia Plus'
};
exports.TAGS = TAGS;
var TEXT_TYPE = {
  tag: {
    type: 'small',
    color: 'secondary',
    iconColor: 'secondaryBlue',
    fontSize: 'titleSmall',
    tagColor: 'blueLight',
    iconType: 'InfoIcon'
  },
  label: {
    type: 'textNormal',
    color: 'greyDarker'
  }
};
exports.TEXT_TYPE = TEXT_TYPE;